/*!

=========================================================
* Argon Design System React - v1.1.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================
*/
import React from "react";
import { Button, Spinner } from "reactstrap";
import { Elements, ElementsConsumer, PaymentElement } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { debugLog } from "../../utils/debug";

debugLog("loading stripe promise using key: " + (window.env.STRIPE_KEY || "pk_live_51PxNXYCr70RV4MrrLBGE6MT7uYjVibCYDwGsYjNldXEhuk0lIvwEYTQKqFhHaN3RK1AhK4gzUin11YQbzzcawCDD00vh3cSoCJ"));
const stripePromise = loadStripe(window.env.STRIPE_KEY || "pk_live_51PxNXYCr70RV4MrrLBGE6MT7uYjVibCYDwGsYjNldXEhuk0lIvwEYTQKqFhHaN3RK1AhK4gzUin11YQbzzcawCDD00vh3cSoCJ");

const uiUrl = window.env.UI_BASE_URL || "http://localhost:3000";

const options = {
  mode: 'subscription',
  amount: 500,
  currency: 'gbp',
  appearance: {
    theme: 'stripe'
  },
};

class CheckoutForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formSubmitted: false,
      errorMessage: null
    };
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    const { stripe, elements } = this.props;

    if (!elements || !stripe) return;

    this.setState({ formSubmitted: true, errorMessage: null });

    const { error: submitError } = await elements.submit();
    if (submitError) {
      console.error("Error during form submission:", submitError);
      this.setState({ formSubmitted: false, errorMessage: submitError.message });
      return;
    }

    const clientSecret = sessionStorage.getItem("clientSecret");
    const intentType = sessionStorage.getItem("intentType");

    if (!clientSecret) {
      debugLog("Missing client secret in sessionStorage");
      this.setState({ formSubmitted: false, errorMessage: "Unable to proceed: Missing payment information." });
      return;
    }

    let result;
    if (intentType === "setup") {
      result = await stripe.confirmSetup({
        elements,
        clientSecret,
        confirmParams: {
          return_url: `${uiUrl}/register/complete`,
        },
      });
    } else {
      result = await stripe.confirmPayment({
        elements,
        clientSecret,
        confirmParams: {
          return_url: `${uiUrl}/register/complete`,
        },
      });
    }

    if (result.error) {
      debugLog("Error during confirmation:", result.error.message);
      this.setState({ formSubmitted: false, errorMessage: result.error.message });
    }
  };

  render() {
    return (
        <>
          <form id="payment-form" onSubmit={this.handleSubmit}>
            <PaymentElement />
            {this.state.errorMessage && (
                <div className="text-danger mt-2">{this.state.errorMessage}</div>
            )}
            <Button
                className="mt-4"
                color="primary"
                type="submit"
                disabled={this.state.formSubmitted}
            >
              {this.state.formSubmitted ? (
                  <>
                    <div className="spinner-container">
                      <Spinner animation="border" role="status">
                        <span className="visually-hidden"></span>
                      </Spinner>
                      &nbsp;Processing...
                    </div>
                  </>
              ) : (
                  "Set up subscription"
              )}
            </Button>
          </form>
        </>
    );
  }
}

const InjectedCheckoutForm = () => (
    <ElementsConsumer>
      {({ stripe, elements }) => (
          <CheckoutForm stripe={stripe} elements={elements} />
      )}
    </ElementsConsumer>
);

export default function InjectedRegisterBillingForm() {
  return (
      <Elements stripe={stripePromise} options={options}>
        <InjectedCheckoutForm />
      </Elements>
  );
}
